<script setup lang="ts">
import EditViewBlock from "@/components/EditView/EditViewBlock.vue";
import {BlockProps} from "@/utils/presenters/interfaces.ts";
import {NamaNavigateToNextEmit, NamaNavigationArgs, NamaVueWidget} from "@/utils/common/NamaVueWidget.ts";
import {ref} from "vue";
import EditViewUtils from "@/utils/editView/EditViewUtils.ts";
import EditScreenList = namaTypes.EditScreenList;

const props = defineProps<BlockProps>();
defineEmits<NamaNavigateToNextEmit>()
const discussionEditorRef = ref<NamaVueWidget>();
const listBlockRef = ref();
const discussionEditor: Record<string, any> = EditViewUtils.fetchDiscussionEditor();
const discussionList: EditScreenList = EditViewUtils.fetchDiscussionList();

function onDiscussionAdded() {
  if (listBlockRef.value)
    listBlockRef.value.fetchBlockWidget().refreshList();
}

function isEdit(): boolean {
  return !EditViewUtils.isNew(props.presenter.place);
}

function canReceiveFocus(): boolean {
  if (!discussionEditorRef.value || !discussionEditorRef.value.canReceiveFocus)
    return false;
  return discussionEditorRef.value.canReceiveFocus();

}

function focus(args: NamaNavigationArgs) {
  if (!discussionEditorRef.value)
    return;
  if (!discussionEditorRef.value.focus)
    return;
  discussionEditorRef.value.focus(args);
}

defineExpose({canReceiveFocus, focus});
</script>

<template>
  <EditViewBlock v-if="isEdit()" :show-main-file="false" :page-index="pageIndex" :block-index="1" :presenter="presenter" :block="discussionList"
                 ref="listBlockRef"/>
  <EditViewBlock :show-main-file="false" :page-index="pageIndex" :block-index="0" :presenter="presenter" :block="discussionEditor"
                 @navigateToNext="(args)=>$emit('navigateToNext', args)" @discussionAdded="onDiscussionAdded" ref="discussionEditorRef"/>
</template>

<style scoped>

</style>
